// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2v4Vf","legacyBtn":"MutateMid_legacyBtn__eye1j"};